import { useEffect } from "react";
import api from "@/lib/api";

/**
 * Fires a single /api/track/visit POST per browser session per path.
 * Uses sessionStorage so refreshes / new tabs don't re-count.
 *
 * Also persists the *first* document.referrer we ever saw for the current
 * browser (localStorage['tex_first_referrer']) so the Sign-Up form can attach
 * it to the registration payload — this preserves the origin website even
 * when the SPA rewrites the URL and the browser drops the Referer header on
 * subsequent requests.
 */
export default function useTrackVisit(path = null) {
  useEffect(() => {
    // Persist the very first referrer we ever saw so signup can report the
    // actual origin website (external referrers only — ignore self / empty).
    try {
      const ref = document.referrer || "";
      const host = ref ? new URL(ref).host : "";
      const ownHost = window.location.host;
      if (ref && host && host !== ownHost && !localStorage.getItem("tex_first_referrer")) {
        localStorage.setItem("tex_first_referrer", ref);
      }
    } catch { /* URL parse or storage may fail — non-fatal */ }

    const p = path || (typeof window !== "undefined" ? window.location.pathname : "/");
    const key = `visit_tracked_${p}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      // sessionStorage might be blocked in privacy modes — still fire once per render
    }
    api
      .post("/track/visit", {
        path: p,
        referrer: document.referrer || "",
      })
      .catch(() => {});
  }, [path]);
}
